/**
 * Query Keys Factory for Secure Messages V2
 * Centralized query key management for message-related queries
 */

const serializeFilters = (filters) => {
  if (!filters || typeof filters !== 'object') return '';
  return JSON.stringify(filters);
};

export const messageQueryKeys = {
  // Message list
  messages: {
    all: ['secure-messages'],
    list: (filters = {}) => ['secure-messages', 'list', serializeFilters(filters)],
  },

  // Message thread details (metadata)
  threadDetails: {
    all: ['secure-messages', 'thread-details'],
    byId: (messageId) => ['secure-messages', 'thread-details', messageId],
  },

  // Message thread replies (new paginated API with offset)
  threadReplies: {
    all: ['secure-messages', 'thread-replies'],
    byId: (messageThreadId) => ['secure-messages', 'thread-replies', messageThreadId],
  },

  // Sidebar messages
  sidebar: {
    all: ['secure-messages', 'sidebar'],
    byThread: (threadId) => ['secure-messages', 'sidebar', 'thread', threadId],
  },

  // Authors / participants list
  authors: {
    all: ['secure-messages', 'authors'],
    byCaseId: (caseId = '') => ['secure-messages', 'authors', caseId],
  },

  // Firm users for assignment
  firmUsers: {
    all: ['secure-messages', 'firm-users'],
  },

  // Case contacts for recipient selection
  caseContacts: {
    all: ['secure-messages', 'case-contacts'],
    byCaseId: (caseId = '') => ['secure-messages', 'case-contacts', caseId],
  },

  // Auto-save drafts
  autoSave: {
    all: ['secure-messages', 'auto-save'],
    byCaseId: (caseId = '') => ['secure-messages', 'auto-save', caseId],
  },

  // Events and tasks for attachments
  eventsAndTasks: {
    all: ['secure-messages', 'events-tasks'],
    byCaseId: (caseId = '') => ['secure-messages', 'events-tasks', caseId],
  },

  // Invite dialog user list
  inviteUsers: {
    all: ['secure-messages', 'invite-users'],
  },
};
